import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation StopProcess($process: ProcessEssentialsDismissInput!) {
    stopProcess(process: $process)
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.StopProcessMutation,
  boolean | undefined,
  'stopProcess'
>('stopProcess', transformers.PASS_THROUGH)

export const executor = graphql.createExecutor<
  graphql.schema.StopProcessMutation,
  void,
  graphql.schema.StopProcessMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
